import React from "react";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";

const SelectionGrid = styled(Grid)({
  boxSizing: "border-box",
  margin: 0,
  padding: "8px",
  width: "100%",
  "& > .MuiGrid-root": {
    minWidth: 0,
  },
  "& .monitoring": {
    boxSizing: "border-box",
    margin: "0 !important",
    minWidth: 0,
    width: "100% !important",
  },
});

type SelectionCardGridProps = React.ComponentProps<typeof Grid>;

const SelectionCardGrid = ({ children, ...props }: SelectionCardGridProps) => (
  <SelectionGrid
    container
    spacing={2}
    data-testid="selection-card-grid"
    {...props}
  >
    {children}
  </SelectionGrid>
);

export default SelectionCardGrid;
